import React from 'react'
import { transactionTimeStamp } from '../../../utils'

const Detail = ({ label, value }) => (
  <div>
    <p className='text-xs font-medium uppercase tracking-wider text-vcm-dark-gray'>{label}</p>
    <p className='mt-2 text-sm font-medium text-gray-900'>{value || <span className='text-gray-400'>Not provided</span>}</p>
  </div>
)

const Section = ({ title, children }) => (
  <section className='border-b border-gray-100 px-5 py-6 last:border-0'>
    <h2 className='font-space-grotesk text-base font-semibold text-gray-900'>{title}</h2>
    <div className='mt-5 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 xl:grid-cols-3'>{children}</div>
  </section>
)

const ParentDetails = ({ parent }) => (
  <div className='overflow-hidden rounded-xl border-gray-200 bg-white shadow-sm'>
    <Section title='Personal information'>
      <Detail label='First name' value={parent?.firstName} />
      <Detail label='Other name(s)' value={parent?.otherNames} />
      <Detail label='Last name' value={parent?.lastName} />
      <Detail label='Date of birth' value={parent?.dob ? transactionTimeStamp(parent.dob).date : null} />
      <Detail label='Gender' value={parent?.gender?.toLowerCase()} />
      <Detail label='Occupation' value={parent?.occupation} />
    </Section>
    <Section title='Contact information'>
      <Detail label='Email address' value={parent?.email} />
      <Detail label='Phone number' value={parent?.phone} />
      <Detail label='Alternate phone' value={parent?.altPhone} />
    </Section>
    <Section title='Employment details'>
      <Detail label='Occupation' value={parent?.occupation} />
      <Detail label='Organisation' value={parent?.employment?.organization} />
      <Detail label='Work address' value={parent?.employment?.address} />
      <Detail label='Work city' value={parent?.employment?.city} />
      <Detail label='Work state' value={parent?.employment?.state} />
    </Section>
    <Section title='Home address'>
      <Detail label='Street address' value={parent?.address?.address} />
      <Detail label='City' value={parent?.address?.city} />
      <Detail label='State' value={parent?.address?.state} />
    </Section>
    <Section title='Origin'>
      <Detail label='Nationality' value={parent?.origin?.nationality} />
      <Detail label='State' value={parent?.origin?.state} />
      <Detail label='LGA' value={parent?.origin?.lga} />
    </Section>
    <Section title='Account information'>
      <Detail label='Email status' value={parent?.userProfile?.emailConfirmed ? 'Confirmed' : 'Pending confirmation'} />
      <Detail label='Account created' value={parent?.createdAt ? transactionTimeStamp(parent.createdAt).date : null} />
      <Detail label='Last updated' value={parent?.updatedAt ? transactionTimeStamp(parent.updatedAt).date : null} />
    </Section>
  </div>
)

export default ParentDetails
